import './ChallengeAdditionalLicensesModal.scss'

import React, {Component} from 'react';

import { Button, Input, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

class ChallengeAdditionalLicenses extends Component {

  constructor(props) {
    super(props)
    this.state = {
      states_in_range: props.states_in_range
    }
  }

  doSubmit = () => {
    this.props.handleSubmit(this.props.dispatch, this.props.base_zip, this.props.agent_distance_category, this.state.states_in_range)
  }

  renderStateOption = (state, idx) => {
    const handleClick = () => {
      let newStatesInRange = this.state.states_in_range.concat()
      newStatesInRange[idx].is_licensed = !newStatesInRange[idx].is_licensed
      this.setState({states_in_range: newStatesInRange})
    }

    return <div key={state.state} className={"LocationModalSelect__item clickable " + (state.is_licensed ? "LocationModalSelect__item--active" : "")}>
      <div onClick={handleClick}>
        <i className="fa fa-check-square-o"></i>
        <i className="fa fa-square-o __checkbox"></i>
        <span className="LocationModalSelect__label">{state.name}</span>
      </div>
      {state.is_licensed ?
        <Input type="text" placeholder="License number" value={state.license_number} onChange={(e) => {
          let newStatesInRange = this.state.states_in_range.concat()
          newStatesInRange[idx].license_number = e.target.value
          this.setState({states_in_range: newStatesInRange})
        }}
        />
        : null}
      {state.state === this.props.base_zip_state && !state.is_licensed ? <div className="LocationModalSelect__error">
        You must be licensed in the state of your home base zipcode.
        Please enter your license number or select a different zipcode.
      </div> : null}
    </div>
  }

  render = () => {
    const shouldDisable = this.state.states_in_range.filter(s => s.is_licensed && !s.license_number).length > 0
      || this.state.states_in_range.filter(s => !s.is_licensed && s.state === this.props.base_zip_state).length > 0

    return (
      <Modal show={this.props.show} className="LocationModal">
        <Modal.Header>
          <Modal.Title>Multi-State Licensing</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="LocationModal__content">
            <p>
              The coverage area you selected includes multiple states.
            </p>
            <p>
              If you wish to receive leads in more than one state, please select any other state where you have
              a real estate license and enter your license number.
            </p>
          </div>
          {this.state.states_in_range.map(this.renderStateOption)}
        </Modal.Body>

        <Modal.Footer>
          <Button bsStyle="default" className="pull-left" onClick={this.props.handleHide}>Cancel</Button>
          <Button bsStyle="primary" className="right" onClick={this.doSubmit} disabled={shouldDisable}>Continue</Button>
        </Modal.Footer>
      </Modal>)
  }
}

let ChallengeAdditionalLicensesModal = connectModal({ name: 'ChallengeAdditionalLicensesModal', destroyOnHide: true })(ChallengeAdditionalLicenses)
export default ChallengeAdditionalLicensesModal
